import { CompanyActionContext } from './CompanyActionContext';
import _ from 'lodash';

export enum CompanyEditingRight {
  Full = 'full-right', // the edited company should be editable
  Partial = 'partial-right', // only some fields should be editable (Customization, Custom fields, Licensing)
  None = 'no-right', // the edited company should be read-only
}

export namespace CompanyEditingRight {
  export function getCompanyEditingRight(
    isEditedCompanyReadOnly: boolean,
    canEditedCompanyBeManagedByAbove: boolean,
    context: CompanyActionContext
  ): CompanyEditingRight {
    // the company should be full editable in Create or MyCompany context
    if (_.includes([CompanyActionContext.Create, CompanyActionContext.MyCompany], context)) {
      return CompanyEditingRight.Full;
    }

    // the root account does not have editing rights for a company managed by a company with the option canBeManagedByAbove:false
    if (isEditedCompanyReadOnly) {
      return CompanyEditingRight.None;
    }

    // the accounts which have visibility over a company with the option canBeManagedByAbove:false
    // should only be able to make changes to Customization, Custom fields and Licensing
    if (!canEditedCompanyBeManagedByAbove) {
      return CompanyEditingRight.Partial;
    }

    return CompanyEditingRight.Full;
  }
}
